import get from "lodash/get";
import { usePageQuery } from "@circle-react/components/SettingsApp/ManageMembers/TabContent/usePageQuery";
import {
  DEFAULT_PAGE_SIZE,
  SORT_OPTIONS_MAP,
  useAllWorkflowsInfiniteQuery,
} from "@circle-react/hooks/useAllWorkflowsInfiniteQuery";
import { useFilterUrl } from "@circle-react-shared/Filter";
import { useWorkflowsData } from "../../../context/WorkflowsDataProvider";

interface UseTableParams {
  status: string;
  workflowType: string;
}

export const useTable = ({ workflowType, status }: UseTableParams) => {
  const { queryParams } = useFilterUrl();
  const { pageSize = DEFAULT_PAGE_SIZE, category } = useWorkflowsData();
  const { setPage, initialPage } = usePageQuery(1, !category);

  const query = String(get(queryParams, "query", ""));

  const infiniteQuery = useAllWorkflowsInfiniteQuery({
    perPage: pageSize,
    sort: SORT_OPTIONS_MAP.LATEST,
    workflowType,
    status,
    initialPage,
    query,
    options: {
      keepPreviousData: false,
    },
  });

  const totalWorkflows = get(infiniteQuery?.pages[0], "total_count", 0);
  const isLoading = infiniteQuery?.isLoading;

  return {
    infiniteQuery,
    totalWorkflows,
    isLoading,
    setPage,
    initialPage,
    defaultPageSize: pageSize,
  };
};
